"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCopy = void 0;
var _react = require("react");
var _common = require("b2b-components/theme/common");
const TOOLTIP_MESSAGE_DURATION = 2500;
const useCopy = config => {
  const {
    value,
    isAutoClear,
    autoClearAfterTime = TOOLTIP_MESSAGE_DURATION
  } = config;
  const [copyStatus, setCopyStatus] = (0, _react.useState)(null);
  const clearTimeoutRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    return () => {
      if (clearTimeoutRef.current) {
        clearTimeout(clearTimeoutRef.current);
      }
    };
  }, []);
  const resetCopyStatus = () => {
    setCopyStatus(null);
  };
  const handleCopyBySelect = () => {
    const body = document.body;
    if (body) {
      const input = document.createElement('input');
      input.value = value;
      input.style.display = 'none';
      body.appendChild(input);
      input.select();
      const isCopied = document.execCommand('copy');
      body.removeChild(input);
      if (!isCopied) {
        throw new Error('Copy has failed');
      }
    } else {
      throw new Error('Cannot access document body');
    }
  };
  const handleCopy = async () => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(value);
      } else {
        handleCopyBySelect();
      }
      setCopyStatus(_common.COPY_STATUS.success);
    } catch (error) {
      setCopyStatus(_common.COPY_STATUS.failure);
    } finally {
      if (isAutoClear) {
        if (clearTimeoutRef.current) {
          clearTimeout(clearTimeoutRef.current);
        }
        clearTimeoutRef.current = setTimeout(resetCopyStatus, autoClearAfterTime);
      }
    }
  };
  return [copyStatus, handleCopy, resetCopyStatus];
};
exports.useCopy = useCopy;
//# sourceMappingURL=useCopy.js.map